import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=d5c8951a&scoped=true"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"
import style0 from "./slider.vue?vue&type=style&index=0&id=d5c8951a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c8951a",
  null
  
)

export default component.exports